import React from 'react';
import styled from 'styled-components';
import { getInstituicaoLogo } from '../../../utils/instituicaoLogos';
import { STATUS_LEGENDA } from './constantes';

const Faixa = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 15px 15px 15px 40px;
  background: #f2f0f0;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #555;
  height: 24px;

  img {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    flex-shrink: 0;
  }
`;

const STATUS = ['CONCEDIDO', 'CONFIRMADA', 'RECUSADO', 'PENDENTE'];

const TIPOS_DE_ESCOLA = [
  { rotulo: 'Escola Pública Federal', naturezaJuridica: 'Pública', esfera: 'Federal' },
  { rotulo: 'Escola Pública Estadual', naturezaJuridica: 'Pública', esfera: 'Estadual' },
  { rotulo: 'Escola Particular Privada', naturezaJuridica: 'Privada', esfera: 'Privada' },
];

const LegendaRelatorio = () => (
  <Faixa>
    {STATUS.map((status) => (
      <Item key={status}>
        <img src={STATUS_LEGENDA[status].icone} alt="" />
        <span>{STATUS_LEGENDA[status].rotulo}</span>
      </Item>
    ))}
    {TIPOS_DE_ESCOLA.map(({ rotulo, naturezaJuridica, esfera }) => (
      <Item key={rotulo}>
        <img src={getInstituicaoLogo({ naturezaJuridica, esfera })} alt="" />
        <span>{rotulo}</span>
      </Item>
    ))}
  </Faixa>
);

export default LegendaRelatorio;
